"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SearchBox = _interopRequireDefault(require("../search-box/SearchBox"));

var _Fetch = _interopRequireDefault(require("../selector/Fetch"));

var _AnimatedLoader = _interopRequireDefault(require("@insided/shared/uikit/AnimatedLoader"));

var _classnames = _interopRequireDefault(require("classnames"));

var _renderProps = require("../../libs/renderProps");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ListSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ListSelector, _Component);

  var _super = _createSuper(ListSelector);

  function ListSelector() {
    var _this;

    (0, _classCallCheck2.default)(this, ListSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      value: ''
    });
    return _this;
  }

  (0, _createClass2.default)(ListSelector, [{
    key: "render",
    value: function render() {
      var _ref,
          _this2 = this;

      var _this$props = this.props,
          header = _this$props.header,
          hasSearch = _this$props.hasSearch,
          _this$props$items = _this$props.items,
          items = _this$props$items === void 0 ? [] : _this$props$items,
          isDynamic = _this$props.isDynamic,
          fetchUrl = _this$props.fetchUrl,
          onLoad = _this$props.onLoad,
          placeholder = _this$props.placeholder,
          children = _this$props.children,
          align = _this$props.align,
          feature = _this$props.feature;
      var value = this.state.value;
      var filtered = items.length && items[0].items ? (_ref = []).concat.apply(_ref, (0, _toConsumableArray2.default)(items)).filter(function (child) {
        return child !== undefined;
      }).filter(function (child) {
        return child.items.some(function (item) {
          return item.title.toLowerCase().includes(value === null || value === void 0 ? void 0 : value.toLowerCase());
        });
      }) : items === null || items === void 0 ? void 0 : items.filter(function (item) {
        return item.title.toLowerCase().includes(value === null || value === void 0 ? void 0 : value.toLowerCase());
      });
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('list-selector-wrapper', align && "list-selector-wrapper--align-".concat(align)),
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, (0, _preact.h)("div", {
        className: "list-selector"
      }, header && header, hasSearch && (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: placeholder,
        feature: feature,
        value: value,
        onSubmit: function onSubmit() {},
        onInput: function onInput(e) {
          return _this2.setState({
            value: e.target.value
          });
        },
        onClear: function onClear() {
          return _this2.setState({
            value: ''
          });
        }
      }), isDynamic ? (0, _preact.h)(_Fetch.default, {
        baseUrl: fetchUrl || '',
        searchValue: value || '',
        onLoaded: onLoad || function () {}
      }, function (_ref2) {
        var loading = _ref2.loading,
            items = _ref2.items;
        if (loading) return (0, _preact.h)("div", {
          className: "loader"
        }, (0, _preact.h)(_AnimatedLoader.default, null));
        if (!loading && items.length === 0) return (0, _preact.h)("div", {
          className: "list-selector-no-results"
        }, "No results found");
        return (0, _renderProps.extractRenderPropsChildren)(children)(items);
      }) : hasSearch ? (filtered === null || filtered === void 0 ? void 0 : filtered.length) === 0 ? (0, _preact.h)("div", {
        className: "list-selector-no-results"
      }, "No results found") : (0, _renderProps.extractRenderPropsChildren)(children)(filtered) : children));
    }
  }]);
  return ListSelector;
}(_preact.Component);

var _default = ListSelector;
exports.default = _default;